function styleHeritageHeading(root = document) {
  const headings = root.querySelectorAll('p.h1');

  headings.forEach((heading) => {
    if (heading.dataset.customStyled === 'true') return;

    const text = heading.textContent
      .trim()
      .replace(/\s+/g, ' ');

    if (!/^D[’']Heritage aviation$/i.test(text)) return;

    heading.innerHTML = `
      <span class="title-primary">D’Heritage</span>
      <span class="title-secondary">aviation</span>
    `;

    heading.dataset.customStyled = 'true';
  });
}

document.addEventListener('DOMContentLoaded', () => {
  styleHeritageHeading();
});

document.addEventListener('shopify:section:load', (event) => {
  styleHeritageHeading(event.target);
});

/* ==========================================================================
   D'HERITAGE v23 (03/10/2026): tamanho obrigatorio na pagina de produto.

   Problema: a pagina abria com cor e tamanho ja escolhidos (ex.: Beige / S).
   Quem nao reparava comprava o tamanho errado: troca, portes e margem perdida.

   Comportamento:
   - So na pagina de produto, so se o produto tem opcao de tamanho com mais de
     um valor, e so quando o URL nao traz ?variant= (link direto a variante).
   - Nenhuma pastilha de tamanho aparece escolhida; o rotulo diz "selecione".
   - O botao (principal e barra fixa) mostra "Selecione o tamanho". Ao tocar,
     a pagina sobe ate aos tamanhos e mostra o aviso; nada vai para o carrinho.
   - Ao tocar num tamanho, tudo volta ao normal e o tema/app tratam do resto.
   - A cor continua pre-escolhida: ve-se na fotografia, nao induz em erro.

   As pastilhas sao desenhadas pelo app Fulbix; os radios do tema estao
   escondidos. Quando a cor ou a manga mudam, o tema redesenha o bloco e o
   Fulbix volta a "clicar" sozinho na pastilha de tamanho para sincronizar.
   Por isso so conta como escolha um toque real do cliente (event.isTrusted),
   e um MutationObserver volta a aplicar o estado enquanto o tamanho falta
   (com setTimeout e nao requestAnimationFrame, que para em separadores em
   segundo plano).
   ========================================================================== */
(function () {
  var SIZE_RE = /^\s*(size|tamanho|taille|talla)\b/i;

  function init() {
    var picker = document.querySelector('variant-picker[context="main_product"]');
    if (!picker) return;
    if (new URLSearchParams(location.search).has('variant')) return;

    var sizeFieldset = Array.prototype.find.call(picker.querySelectorAll('fieldset'), function (fs) {
      var legend = fs.querySelector('legend');
      return legend && SIZE_RE.test(legend.textContent);
    });
    if (!sizeFieldset || sizeFieldset.querySelectorAll('input[type="radio"]').length < 2) return;

    var formId = picker.getAttribute('form-id') || '';
    var pt = (document.documentElement.lang || '').toLowerCase().indexOf('pt') === 0;
    var T = {
      button: pt ? 'Selecione o tamanho' : 'Select a size',
      hint: pt ? 'Escolha um tamanho para continuar.' : 'Choose a size to continue.',
      label: pt ? 'Tamanho: selecione' : 'Size: please select'
    };
    var pending = true;
    var hint = null;
    var observer = null;
    var timer = null;

    function sizeOption() {
      return Array.prototype.find.call(document.querySelectorAll('.fulbix-container .fulbix-option'), function (o) {
        var l = o.querySelector('.fulbix-option-label');
        return l && (SIZE_RE.test(l.textContent) || o.classList.contains('dh-size-pending'));
      });
    }

    function buttons() {
      return document.querySelectorAll('buy-buttons[form="' + formId + '"] button[type="submit"]');
    }

    function apply() {
      if (!pending) return;
      var opt = sizeOption();
      if (opt) {
        if (!opt.classList.contains('dh-size-pending')) opt.classList.add('dh-size-pending');
        var label = opt.querySelector('.fulbix-option-label');
        if (label && label.textContent !== T.label) label.textContent = T.label;
        if (!hint || !opt.contains(hint)) {
          hint = document.createElement('p');
          hint.className = 'dh-size-hint';
          hint.setAttribute('role', 'alert');
          hint.hidden = true;
          opt.appendChild(hint);
        }
      }
      buttons().forEach(function (b) {
        if (b.disabled) return;
        if (!b.classList.contains('dh-needs-size')) {
          b.dataset.dhOriginal = b.innerHTML;
          b.classList.add('dh-needs-size');
        }
        if (b.textContent.trim() !== T.button) b.textContent = T.button;
      });
    }

    function schedule() {
      if (!pending || timer) return;
      timer = setTimeout(function () { timer = null; apply(); }, 40);
    }

    function release(chosenValue) {
      pending = false;
      if (observer) observer.disconnect();
      var opt = sizeOption();
      if (opt) {
        opt.classList.remove('dh-size-pending', 'dh-size-alert');
        var label = opt.querySelector('.fulbix-option-label');
        if (label && label.textContent === T.label && chosenValue) {
          label.textContent = (pt ? 'Tamanho: ' : 'Size: ') + chosenValue;
        }
      }
      if (hint) hint.hidden = true;
      buttons().forEach(function (b) {
        if (b.classList.contains('dh-needs-size')) {
          b.classList.remove('dh-needs-size');
          if (b.dataset.dhOriginal) b.innerHTML = b.dataset.dhOriginal;
          delete b.dataset.dhOriginal;
        }
      });
    }

    function nudge() {
      apply();
      var opt = sizeOption();
      if (!opt) return;
      opt.classList.add('dh-size-alert');
      if (hint) { hint.textContent = T.hint; hint.hidden = false; }
      opt.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    document.addEventListener('click', function (e) {
      if (!pending) return;
      var swatch = e.target.closest && e.target.closest('.fulbix-swatch');
      if (swatch) {
        if (!e.isTrusted) return;
        var opt = swatch.closest('.fulbix-option');
        if (opt && opt === sizeOption()) release(swatch.getAttribute('data-value'));
        return;
      }
      var btn = e.target.closest && e.target.closest('buy-buttons[form="' + formId + '"] button[type="submit"]');
      if (btn && !btn.disabled) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (!pending || !e.isTrusted || (e.key !== 'Enter' && e.key !== ' ')) return;
      var swatch = e.target.closest && e.target.closest('.fulbix-swatch');
      if (swatch && swatch.closest('.fulbix-option') === sizeOption()) release(swatch.getAttribute('data-value'));
    }, true);

    document.addEventListener('submit', function (e) {
      if (pending && e.target && e.target.id === formId) {
        e.preventDefault();
        e.stopImmediatePropagation();
        nudge();
      }
    }, true);

    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    apply();
    // O Fulbix desenha as pastilhas depois do carregamento.
    setTimeout(apply, 400);
    setTimeout(apply, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   D'HERITAGE v28 (27/10/2026): newsletter com escolha (snippet dh-newsletter-choice).
   No envio junta as cartas escolhidas no campo contact[tags]:
   newsletter, journal-casa e/ou journal-aviation, lang-pt ou lang-en.
   Se nada estiver marcado, volta a marcar a carta do universo da pagina.
   ========================================================================== */
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || !form.querySelector) return;
  var box = form.querySelector('[data-dh-nl]');
  var field = form.querySelector('[data-dh-nl-tags]');
  if (!box || !field) return;

  var chosen = Array.prototype.filter.call(box.querySelectorAll('input[type="checkbox"]'), function (c) {
    return c.checked;
  }).map(function (c) {
    return c.value;
  });

  if (!chosen.length) {
    var fallback = box.getAttribute('data-default');
    var input = box.querySelector('input[value="' + fallback + '"]');
    if (input) input.checked = true;
    chosen = [fallback];
  }

  field.value = ['newsletter'].concat(chosen, [box.getAttribute('data-lang')]).join(',');
}, true);
